// extracted by mini-css-extract-plugin
export var cardTitle = "_ci-1";
export var commentBubble = "_ci-e";
export var commentForm = "_ci-a";
export var commentInput = "_ci-b";
export var commentLabel = "_ci-d";
export var commentPrompt = "_ci-9";
export var csatCard = "_ci-0";
export var feedbackSection = "_ci-7";
export var starDisabled = "_ci-6";
export var starEmpty = "_ci-5";
export var starFilled = "_ci-4";
export var starWrapper = "_ci-3";
export var starsContainer = "_ci-2";
export var submittedComment = "_ci-c";
export var thankYouText = "_ci-8";